import type { RaffleRecord } from '../api/types';
import { badgeColor, siteMeta } from '../lib/siteMeta';
import { statusMeta } from '../lib/raffleStatus';
import { relTime } from '../lib/time';

export function RaffleRow({ raffle, onClick }: { raffle: RaffleRecord; onClick?: () => void }) {
  const meta = siteMeta(raffle.site);
  const status = statusMeta(raffle.status);
  const stillOpen = raffle.cutoff !== null && raffle.cutoff * 1000 > Date.now();

  return (
    <div
      className={`frow ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <div className="badge" style={{ background: badgeColor(raffle.site) }}>
        {meta.short}
      </div>
      <div className="main">
        <div className="t">{raffle.product ?? 'Untitled raffle'}</div>
        <div className="m">
          <span>{raffle.site ?? 'unknown source'}</span>
          {raffle.price && (
            <>
              <span className="muted">·</span>
              <span>${raffle.price}</span>
            </>
          )}
          {raffle.cutoff !== null && (
            <>
              <span className="muted">·</span>
              <span>
                {stillOpen ? 'closes ' : 'closed '}
                {relTime(raffle.cutoff)}
              </span>
            </>
          )}
        </div>
      </div>
      <div className="right">
        <span className={`pill ${status.pill}`}>{status.label}</span>
        <div className="when" style={{ marginTop: 6 }}>
          {relTime(raffle.detected_at)}
        </div>
      </div>
    </div>
  );
}
